<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, reactive, computed, nextTick, watch } from "vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import getApiData from "@/api/apiUtil.ts";
import apiYjIndex from "@/api/yjIndex.ts";
import { useRouter } from "vue-router";


const $router = useRouter()
// banner轮播
const bannerSwiper = ref(null);

let prevBan = () => {
  bannerSwiper.value.slidePrev();
};
let nextBan = () => {
  bannerSwiper.value.slideNext();
};

const initBannerSwiper = () => {
  bannerSwiper.value = new Swiper("#bannerSwiper", {
    speed: 800,
    // 开启循环模式，配合箭头可首尾循环切换（仅多于 1 张时生效）
    loop: (data.value?.bannerList || []).length > 1,
    // 复制的幻灯片数量，需与真实 slides 数量一致，保证 loop 切换正常
    loopedSlides: (data.value?.bannerList || []).length || 1,
    /* autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      }, */
  });
};
// 解决方案选中状态
const activeIndex = ref(0);

// 选中下划线（平移指示条）
const tabWrap = ref<any>(null);
const tabItems = ref<HTMLElement[]>([]);
const indicator = reactive({ x: 0, y: 0, width: 0, ready: false });

const setTabItem = (el: any, index: number) => {
  if (el) tabItems.value[index] = el as HTMLElement;
};

const updateIndicator = () => {
  const wrap = (tabWrap.value && tabWrap.value.$el) || tabWrap.value;
  const item = tabItems.value[activeIndex.value];
  if (!wrap || !item) return;
  const wrapRect = wrap.getBoundingClientRect();
  const rect = item.getBoundingClientRect();
  indicator.x = rect.left - wrapRect.left;
  indicator.y = rect.bottom - wrapRect.top - 3;
  indicator.width = rect.width;
  indicator.ready = true;
};

const indicatorStyle = computed(() => ({
  width: `${indicator.width}px`,
  transform: `translate(${indicator.x}px, ${indicator.y}px)`,
  opacity: indicator.ready ? 1 : 0,
}));

const tabActive = (index: number) => {
  activeIndex.value = index;
};

watch(activeIndex, async () => {
  await nextTick();
  updateIndicator();
});
// 企业场景应用选中状态
const activeIdx = ref(0);

const tab1Active = (index: number) => {
  activeIdx.value = index;
  sceneSwiper.value.slideTo(index);
};
// banner轮播
const sceneSwiper = ref(null);

const initSceneSwiper = () => {
  sceneSwiper.value = new Swiper("#sceneSwiper", {
    speed: 800,
    effect: 'fade',
    // loop: true,
    /* autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      }, */
  });
};


const data = ref({
  appList: [],
  bannerList: [],
  caseList: [],
  caseNum: 0,
  countList: [],
  countTitle: '',
  customerList: [],
  industryTitle: '',
  industryList: [],
  rewardList: [],
  serviceList: [],
  coreServiceList: [],
  coreServiceShowNum: 6,
  title: '',
  echnologyPathList: [],
  guandian_link: '',
  guandianList: [],
  cross: []
})

const isMobile = ref(window.innerWidth <= 768);

// 品牌跑马灯：将customerList分块，PC每行6个，移动端每行3个，每3秒向上切换2行
const ROW_SIZE = 6
const MOBILE_ROW_SIZE = 3
const currentRowGroup = ref(0)
let marqueeTimer = null

const allRows = computed(() => {
  const list = data.value?.customerList || []
  const size = isMobile.value ? MOBILE_ROW_SIZE : ROW_SIZE
  const rows = []
  for (let i = 0; i < list.length; i += size) {
    rows.push(list.slice(i, i + size))
  }
  return rows
})

const marqueeTranslateY = ref(0)

function updateMarqueeLayout() {
  nextTick(() => {
    const rows = document.querySelectorAll('.brand-marquee .marquee-row')
    if (rows.length < 2) return
    const rowH = rows[0].offsetHeight
    const gap = rows[1].offsetTop - rows[0].offsetTop - rowH
    const viewport = document.querySelector('.brand-marquee .marquee-viewport')
    if (viewport) {
      viewport.style.height = (rowH * 2 + gap) + 'px'
    }
    marqueeTranslateY.value = currentRowGroup.value * 2 * (rowH + gap)
  })
}

function startMarqueeTimer() {
  stopMarqueeTimer()
  marqueeTimer = setInterval(() => {
    const totalGroups = Math.ceil(allRows.value.length / 2)
    if (totalGroups <= 1) return
    currentRowGroup.value = (currentRowGroup.value + 1) % totalGroups
  }, 3000)
}

function stopMarqueeTimer() {
  if (marqueeTimer) {
    clearInterval(marqueeTimer);
    marqueeTimer = null;
  }
}

watch(currentRowGroup, () => {
  updateMarqueeLayout();
});

const onResize = () => {
  isMobile.value = window.innerWidth <= 768;
  updateIndicator();
  // 断点切换后每行数量变化，重置轮播分组避免 translateY 越界
  currentRowGroup.value = 0;
  updateMarqueeLayout();
};


onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
  window.removeEventListener('load', updateIndicator);
  stopMarqueeTimer();
});


onMounted(async () => {
  window.addEventListener('resize', onResize);
  window.addEventListener('load', updateIndicator);
  data.value = await getApiData(apiYjIndex.index())
  await nextTick();
  updateIndicator();
  startMarqueeTimer();
  updateMarqueeLayout();

  setTimeout(() => {
    // 初始化banner轮播
    initBannerSwiper();

    // 初始化企业场景应用轮播
    initSceneSwiper();

    // 图标加载完成后校正指示条位置
    updateIndicator();
  }, 100);
});

// 点击事件
const handleClick = (item: any) => {
  $router.push({
    path: '/caseDetail',
    query: {
      id: item.id,
      module: 'yj_case'
    }
  });
}



</script>
<template>
  <div class="wp">
    <!-- banner -->
    <div class="banner">
      <a-row class="top">
        <a-col :xl="10" :lg="24" class="title" v-html="data?.title"></a-col>
        <a-col :xl="14" :lg="24" class="right">
          <!-- <p>头条事件</p> -->
          <div class="button" v-if="data?.bannerList?.length > 1">
            <!-- 左箭头：hover 时颜色向左流动 -->
            <svg class="arrow arrow-prev" width="31" height="21" viewBox="0 0 41 21" fill="none"
              xmlns="http://www.w3.org/2000/svg" @click="prevBan">
              <defs>
                <linearGradient id="banner-arrow-flow-prev" x1="0" y1="0" x2="1" y2="0" spreadMethod="repeat">
                  <stop offset="0%" stop-color="#d33328" />
                  <stop offset="6.53%" stop-color="#d33328" />
                  <stop offset="28.81%" stop-color="#fee33c" />
                  <stop offset="44.6%" stop-color="#f3f6d4" />
                  <stop offset="61.73%" stop-color="#5de9f6" />
                  <stop offset="87.99%" stop-color="#2535a0" />
                  <stop offset="100%" stop-color="#d33328" />
                  <animateTransform attributeName="gradientTransform" type="translate" values="0 0;-1 0" dur="1s"
                    repeatCount="indefinite" />
                </linearGradient>
              </defs>
              <path class="arrow-path"
                d="M39.707 10.4141L0.707031 10.4141M9.70703 1.41406L0.707031 10.4141L9.70703 19.4141" stroke="white"
                stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="bevel" />
            </svg>
            <!-- 右箭头：hover 时颜色向右流动 -->
            <svg class="arrow arrow-next" width="31" height="21" viewBox="0 0 41 21" fill="none"
              xmlns="http://www.w3.org/2000/svg" @click="nextBan">
              <defs>
                <linearGradient id="banner-arrow-flow-next" x1="0" y1="0" x2="1" y2="0" spreadMethod="repeat">
                  <stop offset="0%" stop-color="#d33328" />
                  <stop offset="6.53%" stop-color="#d33328" />
                  <stop offset="28.81%" stop-color="#fee33c" />
                  <stop offset="44.6%" stop-color="#f3f6d4" />
                  <stop offset="61.73%" stop-color="#5de9f6" />
                  <stop offset="87.99%" stop-color="#2535a0" />
                  <stop offset="100%" stop-color="#d33328" />
                  <animateTransform attributeName="gradientTransform" type="translate" values="0 0;1 0" dur="1s"
                    repeatCount="indefinite" />
                </linearGradient>
              </defs>
              <path class="arrow-path" d="M1 10.4141L40 10.4141M31 1.41406L40 10.4141L31 19.4141" stroke="white"
                stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="bevel" />
            </svg>
          </div>
        </a-col>
      </a-row>
      <div class="swiper-container" id="bannerSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in data?.bannerList || []" :key="index">
            <div class="img">
              <img :src="item.img" alt="" />
              <video v-if="0" src="" poster="@img/home/banner.jpg" muted loop autoplay webkit-playsinline="true"
                playsinline="true"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solution">
      <a-row class="solution-title">
        <a-col :xl="8" :lg="24">{{ data?.industryTitle }}</a-col>
      </a-row>
      <a-row class="tab" ref="tabWrap">
        <a-col v-for="(item, index) in data?.industryList" :key="index" :xl="4" :lg="24"
          :class="{ active: activeIndex === index }" @click="tabActive(index)">
          <span :ref="(el) => setTabItem(el, index)"><img :src="item.icon" />{{ item.title }}</span>
        </a-col>
        <i class="tab-indicator" :style="indicatorStyle"></i>
      </a-row>
      <a-row justify="space-between" v-if="data?.industryList[activeIndex]">
        <a-col :xl="8" :lg="24" class="list-title">
          <span class="tips-m"> {{ data?.industryList[activeIndex].title }} </span>
          <p>
            {{ data?.industryList[activeIndex].info }}
          </p>
          <span class="tips-pc"
            @click="$router.push(`/industrySolutions?id=${data?.industryList[activeIndex].id}`)">了解更多</span>
        </a-col>
        <a-col :xl="14" :lg="24">
          <a-row class="list" justify="space-between">
            <!-- <router-link :to="`/industrySolutions?id=${data?.industryList[activeIndex].id}&cid=${item.id}&anchor=${item.id}`"> -->
            <a-col v-for="(item, index) in data?.industryList[activeIndex].list" :key="index"
              @click="$router.push(`/industrySolutions?id=${data?.industryList[activeIndex].id}&cid=${item.id}&anchor=${item.id}`)">
              <img :src="item.img" alt="" />
              <div>
                <h5>{{ item.title }} <span>{{ item.shouzhong }}</span></h5>
                <p>
                  {{ item.info }}
                </p>
              </div>
              <img class="hover-img" :src="item.hoverImg" alt="">
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
    <div class="body-line"></div>

    <!-- 行业积累 -->
    <div class="accumulate">
      <a-row justify="space-between">
        <a-col :lg="24" :xl="8" class="title">
          {{ data?.countTitle }}
        </a-col>
        <a-col :lg="24" :xl="14" class="list">
          <ul>
            <li v-for="(item, index) in data?.countList" :key="index">
              <span v-html="item.count"></span>
              <p v-html="item.title"></p>
            </li>
          </ul>
        </a-col>
      </a-row>
    </div>

    <div class="body-line mt30"></div>
    <!-- 技术路径 -->
    <div class="wp1">
      <div class="service-app" v-if="(data?.coreServiceShowNum || 0) > 0">
        <h3>技术路径</h3>
        <a-row :gutter="{ md: 0, lg: 20, xl: 30 }" class="list">
          <a-col v-for="(item, index) in data?.echnologyPathList" :key="index" :md="24" :lg="12" :xl="8" class="item">
            <a class="con">
              <div class="img">
                <img :src="item.image" alt="" />
                <!--              <img :src="item.img" alt="" @click="$router.push(`/detail?id=${item.id}&module=yj_app_list`) " />-->
              </div>
              <h5>{{ item.title }}</h5>
              <p>
                {{ item.description }}
              </p>
            </a>
          </a-col>
        </a-row>
      </div>
    </div>

    <!-- 观点 -->
    <div class="technology-path">
      <div class="tp-col">
        <div class="tp-item" v-for="item in data?.guandianList || []" :key="item.id">
          <div class="tp-text">
            <p class="en">{{ item.tag }}</p>
            <div class="bl">
              <h4>{{ item.title }}</h4>
              <p class="desc">{{ item.description }}</p>
            </div>
          </div>
          <div class="tp-pic">
            <img class="tp-img" :src="item.img" alt="" />
            <!-- <img class="tp-img tp-img-hover" :src="item.image2" alt="" /> -->
          </div>
        </div>
      </div>
      <div class="more">
        查看完整技术路径
        <a :href="data?.guandian_link || ''">了解更多</a>
      </div>
    </div>
    <div class="body-line"></div>

    <!-- 品牌 -->
    <div class="brand-marquee">
      <div class="marquee-viewport">
        <div class="marquee-inner" :style="{ transform: `translateY(-${marqueeTranslateY}px)` }">
          <div class="marquee-row" v-for="(row, rIdx) in allRows" :key="'row-' + rIdx">
            <span class="pic" v-for="(item, index) in row" :key="'item-' + rIdx + '-' + index">
              <img :src="item.white_logo" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="body-line mt30"></div>
    <!-- 作品案例 -->
    <div class="case">
      <div class="topping" v-if="data?.caseList.length > 0 && !isMobile">
        <a-row :gutter="{ lg: 0, xl: 30 }">
          <a-col :lg="24" :xl="10" class="left">
            <div class="top">
              <h2>项目集录</h2>
            </div>
            <div class="bl">
              <img class="logo" :src="data?.caseList[0].pinpaiImage" alt="" />
              <span class="tips">{{ data?.caseList[0].brand }}</span>
              <h3 @click="handleClick(data?.caseList[0])">{{ data?.caseList[0].title }}</h3>
              <span class="desc">{{ data?.caseList[0].hangye_name }} {{ data?.caseList[0].jiejuefangan_name }} <span> |
                  {{ data?.caseList[0].shouzhong }}</span></span>
              <div class="category">{{ (data?.caseList[0].categoryName || '').split(',').join(' ') }}</div>
            </div>
          </a-col>
          <a-col :lg="24" :xl="14" class="right">
            <div class="pic">
              <div class="img" @click="handleClick(data?.caseList[0])"
                :style="'background-image: url(' + data?.caseList[0].cover + ');'"></div>
              <!-- <img :src="data?.caseList[0].cover" alt="" /> -->
            </div>
          </a-col>
        </a-row>

      </div>
      <div class="ue-info" v-if="data?.caseList.length > 0 && !isMobile" @click="handleClick(data?.caseList[0])">
        <div class="pic">
          <!-- <div class="img" :style="'background-image: url(' + data?.caseList[0].cover + ');'"></div> -->
          <img :src="data?.caseList[0].cover" alt="" class="img">
        </div>
        <div class="top">
          <div class="l">
            <div class="date">2022-10</div>
            <div class="tips">{{ data?.caseList[0].brand }}</div>
          </div>
          <div class="r">
            <img class="logo" :src="data?.caseList[0].pinpaiImage" alt="" />
          </div>
        </div>
        <div class="tit">{{ data?.caseList[0].title }}</div>
      </div>
      <ul class="list" v-if="data?.caseList.length > 1">
        <li v-for="item in data?.caseList.slice(isMobile ? 0 : 1)" :key="item.id" @click="handleClick(item)">
          <!-- <div class="img">
            <img :src="item.cover" />
          </div> -->
          <div class="zhezhao"><img src="@img/case-zhezhao.png" alt="" /></div>
          <div class="pic">
            <div class="img" :style="'background-image: url(' + item.cover + ');'"></div>
          </div>
          <img :src="item.pinpaiImage" class="logo" />
          <div class="text">
            <span class="tips">{{ item.brand }}</span>
            <h3>{{ item.title }}</h3>
            <span class="desc">{{ item.hangye_name }}・{{ item.jiejuefangan_name }} <span> | {{ item.shouzhong
                }}</span></span>
          </div>
          <div class="border"></div>
        </li>

      </ul>
      <svg width="210" height="22" viewBox="0 0 210 22" fill="none" xmlns="http://www.w3.org/2000/svg"
        class="more more-arrow" @click="$router.push('/WorkList')">
        <defs>
          <linearGradient id="more-arrow-gradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="210" y2="0"
            spreadMethod="repeat">
            <stop offset="0%" stop-color="#d33328" />
            <stop offset="6.53%" stop-color="#d33328" />
            <stop offset="28.81%" stop-color="#fee33c" />
            <stop offset="44.6%" stop-color="#f3f6d4" />
            <stop offset="61.73%" stop-color="#5de9f6" />
            <stop offset="87.99%" stop-color="#2535a0" />
            <stop offset="100%" stop-color="#d33328" />
            <animateTransform attributeName="gradientTransform" type="translate" values="0 0;210 0" dur="1s"
              repeatCount="indefinite" />
          </linearGradient>
        </defs>
        <g class="more-arrow-group">
          <path class="more-arrow-head" d="M200 2L204.5 6.5L209 11L200 20" stroke="white" stroke-width="2"
            stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="bevel" />
          <path class="more-arrow-line" d="M208 11L-6.3777e-06 11" stroke="white" stroke-width="2"
            stroke-linejoin="bevel" />
        </g>
      </svg>
    </div>
    <!-- 场景应用 -->
    <div class="scene" v-if="false">
      <div class="swiper-container" id="sceneSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in data?.appList" :key="index">
            <a-row justify="space-between" class="con">
              <a-col :lg="24" :xl="8" class="left">
                <div class="info">
                  <span>{{ item.viceTitle }}</span>
                  <h3>{{ item.title }}</h3>
                  <p>
                    {{ item.info }}
                  </p>
                  <router-link class="g-btnl" to="">了解更多<img src="@img/Metaverse/iconl1.png" alt=""></router-link>
                </div>
              </a-col>
              <a-col :lg="24" :xl="14" class="img">
                <img :src="item.img" alt="" />
                <!-- 如果是视频 -->
                <div class="g-videol" v-if="0">
                  <video ref="videoElement"
                    src="http://yuanjingcar.dev3.lishengli.xin//uploads/20240720/7b1c704ba8052c8780f61a2924c84f1b.mp4"
                    poster="@img/home/scene-img-1.jpg" class="video" muted loop :autoplay="isPlaying"
                    webkit-playsinline="true" playsinline="true"></video>
                  <div class="play" @click="togglePlay">
                    <img src="@img/playl.png" alt="">
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <ul>
            <li v-for="(item, index) in data?.appList.slice(0, 3)" :key="index" :class="{ active: activeIdx === index }"
              @click="tab1Active(index)">
              <a>{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div class="item">
          <ul>
            <li v-for="(item, index) in data?.appList.slice(3)" :key="index"
              :class="{ active: activeIdx === 3 + index }" @click="tab1Active(3 + index)">
              <a>{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="body-line"></div>
    <!-- 荣誉-->
    <div class="honor">
      <a-row justify="space-between">
        <a-col :lg="24" :xl="8" class="title"> 与伙伴一起获得荣誉 </a-col>
        <a-col :lg="24" :xl="14" class="list">
          <ul>
            <li v-for="(item, index) in data?.rewardList" :key="index">
              <img :src="item.img" alt="" />
            </li>
          </ul>
        </a-col>
      </a-row>
    </div>
    <div class="body-line"></div>
    <!-- 跨界基因 -->
    <div class="cross">
      <div class="title">跨界基因</div>
      <div class="list">
        <div class="item" v-for="(item, index) in data?.cross || []" :key="index">
          <div class="bg" :style="'background-image:url(' + item.img + ')'"></div>
          <div class="mask"></div>
          <div class="con">
            <img class="icon" :src="item.icon" alt="" />
            <div class="info">
              <h5>{{ item.title }}</h5>
              <p class="desc">{{ item.viceTitle }}</p>
              <p class="detail">{{ item.info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped lang="less">
.body-line.mt30 {
  margin-top: 30rem;
}

.banner {
  .top {
    height: 260rem;
    display: flex;
    align-items: center;

    .title {
      font-size: 57rem;
      line-height: 1.2em;
      // font-weight: bold;
      padding-top: 14rem;
      background: var(--1,
          linear-gradient(92deg,
            #d33328 6.53%,
            #fee33c 28.81%,
            #f3f6d4 44.6%,
            #5de9f6 61.73%,
            #2535a0 87.99%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .right {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      font-size: 20rem;
      flex-direction: column;

      p {
        font-weight: bold;
      }

      .button {
        margin-top: 42rem;
        font-weight: 700;

        svg {
          margin-left: 24rem;
          cursor: pointer;

          .arrow-path {
            stroke: white;
          }

          &:hover.arrow-prev .arrow-path {
            stroke: url(#banner-arrow-flow-prev);
          }

          &:hover.arrow-next .arrow-path {
            stroke: url(#banner-arrow-flow-next);
          }
        }
      }
    }
  }

  .img {
    img {
      width: 100%;
    }
  }
}

// 解决方案
.solution {
  .solution-title {
    >div {
      font-size: 30rem;
      padding: 70rem 0;
    }
  }

  .tab {
    position: relative;

    >div {
      opacity: 0.5;
      font-size: 20rem;
      transition: opacity 0.6s ease;

      &:hover {
        opacity: 0.8;
      }

      span {
        display: flex;
        align-items: center;
        position: relative;
        width: max-content;
        padding-bottom: 7rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        cursor: pointer;

        >img {
          margin-right: 12rem;
        }
      }

      &.active {
        opacity: 1;
      }
    }

    .tab-indicator {
      position: absolute;
      top: 0;
      left: 0;
      height: 3px;
      width: 0;
      opacity: 0;
      pointer-events: none;
      background: linear-gradient(90deg,
          #d33328 7.35%,
          #fee33c 32.74%,
          #f3f6d4 50.71%,
          #5de9f6 70.23%,
          #2535a0 100.14%);
      transition: transform 0.3s ease, width 0.3s ease, opacity 0.3s ease;
    }
  }

  .list-title {
    p {
      font-size: 30rem;
      line-height: 1.2em;
      padding-bottom: 32rem;
      padding-top: 53rem;
      letter-spacing: 0;
      padding-right: 20rem;
    }

    .tips-m {
      display: none;
    }

    .tips-pc {
      display: inline-block;
      border: 1px solid #ffffff;
      padding: 10rem 20rem;
      cursor: pointer;
      position: relative;
      z-index: 0;

      &:hover {
        border-color: transparent;
        background:
          linear-gradient(#000000, #000000) padding-box,
          conic-gradient(from var(--bg-angle), #D33328 6.53%, #FEE33C 28.81%, #F3F6D4 44.6%, #5DE9F6 51.73%, #2535A0 70.99%, #D33328 99%) border-box;
        animation: spin 2.5s infinite linear;
      }
    }

    span {
      font-size: 18rem;
    }
  }

  .list {
    margin-top: 56rem;
    border-left: 1px solid #220d0d;
    padding-left: 30rem;
    display: flex;
    flex-wrap: wrap;
    letter-spacing: normal;

    >div {
      display: flex;
      margin-bottom: 50rem;
      margin-top: 50rem;
      width: 48%;
      position: relative;
      height: 80rem;
      align-items: center;
      cursor: pointer;

      &:before {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 1px;
        background: #2b2b2b;
        margin-bottom: -50rem;
      }

      &:nth-child(1),
      &:nth-child(2) {
        padding-top: 0;
      }

      &:nth-last-child(1),
      &:nth-last-child(2) {
        &:before {
          display: none;
        }
      }

      >img {
        width: 64rem;
        margin-right: 32rem;
        height: 64rem;
      }

      h5 {
        font-size: 20rem;
        letter-spacing: 0;

        span {
          font-size: 16rem;
          font-weight: normal;
          color: #707070;
          border-left: 1px solid #707070;
          height: 16rem;
          line-height: 13rem;
          display: inline-block;
          margin-left: 5px;
          padding-left: 5px;
        }
      }

      p {
        font-size: 16rem;
        color: #707070;
        margin-top: 8rem;
        text-align: justify;
        text-align-last: left;
      }
    }

    .hover-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: opacity 0.6s;
      opacity: 0;

      &:hover {
        opacity: 1;
      }
    }
  }
}

// 技术路径
.technology-path {
  margin-top: 68rem;

  .type-title {
    font-size: 38rem;
    padding: 70rem 0;
  }

  .tp-col {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .tp-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 865rem;
    height: 359rem;
    cursor: pointer;

    margin-top: 30rem;

    .tp-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      box-sizing: border-box;
      width: 286rem;
      height: 359rem;
      background: #f3f3f3;
      padding: 20rem 24rem 24rem;

      .en {
        font-size: 14rem;
        line-height: 28rem;
        color: #868686;
        transition: color 0.6s;
      }

      .bl {
        color: #000000;

        h4 {
          font-size: 20rem;
          line-height: 28rem;
          font-weight: normal;
          transition: transform 0.6s 0.1s;
        }

        .desc {
          width: 238rem;
          margin-top: 8rem;
          font-size: 14rem;
          line-height: 22rem;
          transition: all 0.6s;
          color: #838383;
        }
      }
    }

    .tp-pic {
      position: relative;
      overflow: hidden;
      width: 571rem;
      height: 359rem;

      .tp-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s, opacity 0.6s;
      }

      .tp-img-hover {
        opacity: 0;
        transform: scale(1.06);
      }
    }

    &:hover {
      .tp-text {
        .en {
          color: #000;
        }

        .bl {
          h4 {
            transform: translateY(-170rem);
            transition: all 0.6s;
            font-weight: bold;
          }

          .desc {
            transform: translateY(-170rem);
            transition: all 0.6s 0.1s;
            color: #000;
          }
        }
      }

      .tp-pic {
        .tp-img {
          // opacity: 0;
          transform: scale(1.05);
        }

        // .tp-img-hover {
        //   opacity: 1;
        //   transform: scale(1);
        // }
      }
    }
  }

  .more {
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
    width: 100%;
    text-align: center;
    margin-top: 60rem;

    a {
      display: block;
      margin: 26rem auto;
      width: 86rem;
      height: 34rem;
      border: 1px solid #FFF;
      font-size: 14rem;
      font-style: normal;
      font-weight: 400;
      line-height: 22rem;
      color: #FFF;
      text-align: center;
      line-height: 34rem;
      box-sizing: border-box;
      position: relative;
      z-index: 0;

      &:hover {
        border-color: transparent;
        background:
          linear-gradient(#000000, #000000) padding-box,
          conic-gradient(from var(--bg-angle), #D33328 6.53%, #FEE33C 28.81%, #F3F6D4 44.6%, #5DE9F6 51.73%, #2535A0 70.99%, #D33328 99%) border-box;
        animation: spin 2.5s infinite linear;
      }
    }
  }
}

// 品牌跑马灯
.brand-marquee {
  margin-top: 68rem;
  overflow: hidden;
  position: relative;

  .marquee-viewport {
    overflow: hidden;
    // height set dynamically via JS
  }

  .marquee-inner {
    transition: transform 0.6s ease;
  }

  .marquee-row {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-bottom: 20rem;

    &:last-child {
      margin-bottom: 0;
    }

    .pic {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 128rem;
      margin-right: 0rem;
      flex-shrink: 0;

      img {
        display: block;
        height: 100%;
        width: auto;
        object-fit: contain;
      }
    }
  }

  .zhezhao {
    position: absolute;
    left: -50rem;
    height: 100%;
    z-index: 1;

    img {
      height: 100%;
    }

    &.right {
      right: -50rem;
      left: auto;
      transform-origin: left;

      img {
        transform: scale(-1, 1);

      }
    }
  }
}

// 案例
.case {
  margin-top: 68rem;

  .topping {
    .left {
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      h2 {
        font-size: 38rem;
        font-weight: 400;
        cursor: pointer;
      }

      .logo {
        margin-top: 52rem;
        margin-top: 52rem;
        max-width: 150rem;
        max-height: 50rem;
      }

      .bl {
        font-size: 18rem;

        h3 {
          font-size: 32rem;
          width: fit-content;
          margin: 32rem 0;
          font-weight: 500;
          position: relative;
          cursor: pointer;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            right: auto;
            left: 0;
            width: 100%;
            height: 1px;
            background: #ffffff;
            transform: scaleX(0);
            transition: transform 0.6s;
            transform-origin: left;
          }
        }

        .desc {
          span {
            color: #868686;
          }
        }

        .category {
          line-height: 22rem;
          color: #868686;
          margin-top: 14rem;
        }
      }
    }

    .right {
      .pic {
        padding-top: 56.114398422%;
        position: relative;
        height: 0;
        overflow: hidden;

        .img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -ms-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          cursor: pointer;
          transition: transform 0.6s;
        }
      }

      // > img {
      //   width: 100%;
      // }
    }

    &:hover {
      .img {
        transform: scale(1.06);
      }
    }
  }

  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 39rem;

    @property --bg-angle {
      inherits: false;
      initial-value: 0deg;
      syntax: "<angle>";
    }

    @keyframes spin {
      to {
        --bg-angle: 360deg;
      }
    }

    li {
      width: 31%;
      position: relative;
      margin-top: 30rem;
      transition: opacity 0.4s;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      animation: spin 2.5s infinite linear paused;
      background: linear-gradient(to bottom, transparent, transparent) padding-box,
        conic-gradient(from var(--bg-angle),
          #d33328 6.53%,
          #fee33c 28.81%,
          #f3f6d4 44.6%,
          #5de9f6 51.73%,
          #2535a0 70.99%,
          #d33328 99%) border-box;

      .zhezhao {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }

      &:hover {
        animation-play-state: running;
      }

      .border {
        top: 0;
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        z-index: 1;
        transition: all 0.4s;
      }

      // .img {
      //   background: #000000;
      //   transition: transform 0.5s;
      //   > img {
      //     width: 100%;
      //     display: block;
      //     transition: opacity 0.5s;
      //   }
      // }
      .pic {
        padding-top: 56.22710622%;
        position: relative;
        height: 0;
        overflow: hidden;
        background: #000000;
        // transition:transform 0.5s;
        transition: .5s;

        .img {
          width: 100%;
          display: block;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-repeat: no-repeat;
          background-position: center center;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -ms-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          transition: .5s;
        }
      }

      .logo {
        position: absolute;
        top: 30rem;
        left: 30rem;
        max-height: 32rem;
        max-width: 147rem;
      }

      .text {
        position: absolute;
        left: 30rem;
        bottom: 30rem;
        z-index: 2;

        h3 {
          font-size: 20rem;
          // font-weight: 600;
          font-weight: normal;
          margin: 5rem 0 9rem;
        }

        .desc {
          font-size: 14rem;
          color: #c2c2c2;
          transition:all 0.6s;
        }
      }

      &:hover {
        .pic {
          transform: scale(0.98, 0.97);

          .img {
            opacity: 0.6;
          }
        }
        .text{
          .desc{
            color:#ffffff;
          }
        }
      }
    }
  }

  .more {
    width: 209rem;
    margin: 0 auto;
    margin-top: 60rem;
    display: block;
    cursor: pointer;

    &.more-arrow {
      position: relative;
      overflow: visible;

      .more-arrow-group {
        transform-box: fill-box;
        transform-origin: center;
        transform: scaleX(0.92);
        transition: transform 0.4s ease;
      }

      &:hover .more-arrow-group {
        transform: scaleX(1);
      }

      &:hover .more-arrow-head,
      &:hover .more-arrow-line {
        stroke: url(#more-arrow-gradient);
      }
    }
  }
}

// 场景
.scene {
  margin-top: 68rem;
  position: relative;

  .swiper-slide.swiper-slide-active {
    opacity: 1 !important;
  }

  .swiper-slide {
    opacity: 0 !important;
  }

  .left {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    h3 {
      font-size: 26rem;
      margin: 18rem 0 16rem;
    }

    span,
    p {
      // font-size: 16rem;
      font-size: 15rem;
      line-height: 24rem;
      margin-bottom: 23rem;
      text-align: justify;
    }
  }

  .img {
    img {
      width: 100%;
    }
  }

  .list {
    position: absolute;
    bottom: -18rem;
    left: 0;
    width: 33.33%;
    z-index: 2;
  }

  .list {
    display: flex;

    >div {
      width: 100%;
    }
  }

  ul {
    width: max-content;

    li {
      width: 100%;
      position: relative;

      &:nth-last-child(1) {
        a {
          border: 0;
        }
      }

      a {
        color: #888888;
        font-size: 20rem;
        line-height: 64rem;
        border-bottom: 1px solid #2b2b2b;
        display: block;
        cursor: pointer;
      }

      &.active {
        a {
          display: block;
          color: #ffffff;
          width: 100%;

          &:after {
            content: "";
            display: block;
            height: 3px;
            position: absolute;
            bottom: 0;
            width: 100%;
            background: linear-gradient(90deg,
                #d33328 6.76%,
                #fee33c 29.83%,
                #f3f6d4 46.16%,
                #5de9f6 63.9%,
                #2535a0 91.07%);
          }
        }
      }
    }
  }
}

.g-btnl {
  overflow: hidden;
  font-size: 16rem;
  line-height: 1.562em;
  color: #fff;
  cursor: pointer;

  img {
    display: inline-block;
    vertical-align: middle;
    width: 16rem;
    height: 12rem;
    margin-top: -2rem;
    margin-left: 13rem;
  }
}

// 行业累计
.accumulate {
  margin-top: 62rem;

  .title {
    font-size: 38rem;
  }

  .list {
    ul {
      display: flex;

      li {
        width: 20%;
        text-align: center;
        position: relative;

        span {
          font-size: 46rem;
          font-weight: bold;
          line-height: 68rem;
          height: 68rem;
          margin-top: 12rem;
          display: block;
          // border-right: 1px solid #2b2b2b;
        }

        // hover 时数字呈品牌渐变从左向右流动（色标与 banner 箭头一致）
        &:hover span {
          background-image: linear-gradient(90deg,
              #d33328 0%,
              #d33328 6.53%,
              #fee33c 28.81%,
              #f3f6d4 44.6%,
              #5de9f6 61.73%,
              #2535a0 87.99%,
              #d33328 100%);
          background-size: 200% 100%;
          background-repeat: repeat-x;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: accumulate-count-flow 1s linear infinite;
        }

        p {
          margin-top: 36rem;
          color: #838383;
        }
      }

      li:after {
        content: "";
        position: absolute;
        top: 6rem;
        right: 0;
        width: 0;
        bottom: 39rem;
        border-right: 1px solid #2b2b2b;
      }

      li:last-child::after {
        display: none;
      }
    }
  }
}

@keyframes accumulate-count-flow {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: 0% 0;
  }
}

// 荣誉
.honor {
  margin-top: 68rem;

  .title {
    font-size: 38rem;
  }

  .list {
    ul {
      overflow: hidden;

      li {
        float: left;
        width: 20%;
        height: 120rem;
        // padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: 68%;
          max-height: 35%;
          object-fit: contain;
        }
      }
    }
  }
}

// 跨界基因
.cross {
  margin-top: 68rem;

  .title {
    font-size: 38rem;
    line-height: 45rem;
    color: #ffffff;
    white-space: nowrap;
  }

  .list {
    display: flex;
    align-items: flex-start;
    margin-top: 85rem;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      position: relative;
      width: 398rem;
      height: 680rem;
      margin-right: 39rem;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 40rem;

      &:last-child {
        margin-right: 0;
      }

      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: opacity 0.5s;
      }

      .con {
        position: relative;
        height: 100%;

        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 104rem;
          height: 104rem;
          transform: translate(-50%, -50%);
          transition: transform 0.5s;
        }

        .info {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f2f2f2;
          padding: 45rem 44rem 50rem;
          box-sizing: border-box;
          transform: translateY(100%);
          transition: transform 0.5s;

          h5 {
            font-size: 20rem;
            line-height: 28rem;
            font-weight: 400;
            color: #000000;
            opacity: 0;
            transform: translateY(30rem);
            transition: all 0.4s ease 0.12s;
          }

          .desc {
            width: 312rem;
            margin-top: 20rem;
            font-size: 16rem;
            line-height: 24rem;
            color: #2d2d2d;
            opacity: 0;
            transform: translateY(30rem);
            transition: all 0.4s ease 0.24s;
          }

          .detail {
            width: 312rem;
            margin-top: 114rem;
            font-size: 16rem;
            line-height: 24rem;
            color: #858585;
            opacity: 0;
            transform: translateY(30rem);
            transition: all 0.4s ease 0.36s;
          }
        }
      }

      &:hover {
        .mask {
          opacity: 1;
        }

        .con {
          .icon {
            transform: translate(-50%, -290rem);
          }

          .info {
            transform: translateY(0);

            h5 {
              opacity: 1;
              transform: translateY(0);
            }

            .desc {
              opacity: 1;
              transform: translateY(0);
            }

            .detail {
              opacity: 1;
              transform: translateY(0);
            }
          }
        }
      }
    }
  }
}

// 核心服务应用
.service-app {
  margin-top: 68rem;

  // padding-bottom: 62rem;
  h3 {
    font-size: 38rem;
    font-weight: 500;
  }

  .list {
    margin-top: 17rem;

    .item {
      position: relative;
      margin-top: 40rem;

    }

    .con {
      display: block;
      overflow: hidden;
      position: relative;
      animation: spin 2.5s infinite linear paused;
      background:
        linear-gradient(to bottom, transparent, transparent) padding-box,
        conic-gradient(from var(--bg-angle), #D33328 6.53%, #FEE33C 28.81%, #F3F6D4 44.6%, #5DE9F6 51.73%, #2535A0 70.99%, #D33328 99%) border-box;

      &:hover {
        animation-play-state: running;

      }

      &:hover {
        .img {
          transform: scale(0.98, 0.97);
        }
      }

      .img {
        background: #000;
        display: block;
        width: 100%;
        height: 100%;
        transition: .5s;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      h5 {
        position: absolute;
        font-size: 26rem;
        top: 44rem;
        left: 40rem;
        font-weight: 500;
        color: #fff;
      }

      p {
        position: absolute;
        top: 107rem;
        left: 40rem;
        color: #dadada;
        margin-right: 52rem;
      }
    }
  }
}

.g-videol {
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;

  .video {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play {
    position: absolute;
    width: 48rem;
    height: 48rem;
    right: 41rem;
    bottom: 56rem;
    overflow: hidden;
    z-index: 10;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}

.wp1 {
  max-width: 1760px;
  width: 100%;
  margin: 0 auto;
}

@media only screen and (max-width: 1440px) {
  .solution {
    .tab {
      >div {
        font-size: 16rem;

        span {
          img {
            width: 36rem;
          }
        }
      }
    }
  }
}



@media only screen and (max-width: 1200px) {
  .wp1 {
    width: auto;
    max-width: none;
  }

  .banner {
    .top {
      height: auto;
      padding: 21rem 0 10rem;

      .title {
        font-size: 34rem;
        line-height: 1.205em;
        margin-bottom: 28rem;
      }

      .right {
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        font-size: 16rem;
        width: 100%;

        .button {
          margin-top: 0;

          svg {
            width: 32rem;
            height: 32rem;
          }
        }
      }
    }
  }



  // 解决方案
  .solution {

    .list {
      border: none;

    }
  }

  // 技术路径
  .technology-path {
    display: block;

    .tp-col {
      width: 100%;
    }

    .tp-item {
      width: 100%;
    }
  }

  // 品牌跑马灯
  .brand-marquee {
    margin-top: 42rem;

    .marquee-row {
      .pic {
        height: 100rem;
        margin-right: 20rem;
      }
    }
  }

  // 作品案例

  .case {
    margin-top: 42rem;

    .topping {
      display: none;

      .left {
        .top {
          display: flex;
          align-items: center;
          align-content: center;
          justify-content: space-between;
        }

        // display: block;
        h2 {
          font-size: 28rem;
          line-height: 1.214em;
        }

        .logo {
          width: 87rem;
          margin-top: 0;
        }

        .bl {
          overflow: hidden;
          margin-bottom: 30rem;

          h3 {
            font-size: 28rem;
            line-height: 1.214em;
            width: auto;
            margin: 20rem 0;

            br {
              display: none;
            }
          }

          span:first-child {
            display: none;
          }
        }
      }
    }
  }

  // 场景
  .scene {
    margin-top: 56rem;

    +.body-line {
      display: none;
    }

    .con {
      flex-wrap: wrap-reverse;

      .left {
        .info {
          padding-top: 16rem;
        }

        span,
        p {
          font-size: 16rem;
          line-height: 1.5em;
        }

        h3 {
          font-size: 28rem;
          line-height: 1.214em;
          margin: 21rem 0 8rem;
        }

        p {
          color: #86868b;
        }
      }
    }

    .list {
      position: static;
      width: auto;
      justify-content: space-between;
      margin-top: 80rem;

      .item {
        width: 46%;
      }
    }

    ul {
      width: 100%;

      li {
        &:nth-last-child(1) {
          a {
            border-bottom: 1px solid #2b2b2b;
          }
        }

        a {
          font-size: 17rem;
          letter-spacing: 0;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          line-height: 54rem;
        }
      }
    }
  }

  .g-btnl {
    overflow: hidden;
    font-size: 16rem;
    line-height: 1.562em;
    color: #fff;
    cursor: pointer;

    img {
      display: inline-block;
      vertical-align: middle;
      width: 16rem;
      height: 12rem;
      margin-top: -2rem;
      margin-left: 13rem;
    }
  }

  // 行业累计
  .accumulate {
    margin-top: 53rem;

    .title {
      font-size: 28rem;
      line-height: 1.214em;
      overflow: hidden;
    }

    .list {
      margin-top: 36rem;
      width: 100%;

      ul {
        flex-wrap: wrap;

        li {
          width: 20%;
          box-sizing: border-box;
          border-right: 1px solid #2b2b2b;
          height: 145rem;
          padding-top: 7rem;

          &:nth-child(3n) {
            border-right: none;
          }

          &:nth-child(1),
          &:nth-child(2) {
            border-top: none;
          }

          span {
            border-right: none;
            font-size: 34rem;
            line-height: 1.823em;
            height: auto;
            font-style: italic;
          }

          p {
            color: #838383;
            font-size: 14rem;
            margin-top: 21rem;
          }
        }
      }
    }
  }

  // 荣誉
  .honor {
    margin-top: 53rem;

    .title {
      font-size: 28rem;
      line-height: 1.214em;
    }

    .list {
      margin-top: 21rem;

      ul {
        li {
          width: 33.33%;
        }
      }
    }
  }

  // 核心服务应用
  .service-app {
    margin: 55rem 0 33rem;
    padding-bottom: 0;

    h3 {
      font-size: 28rem;
      line-height: 1.214em;
      width: 89%;
      margin: 0 auto;
    }

    .list {

      .item {
        margin: 0 0 20rem;
      }

      .con {

        img {
          width: 100%;
          height: 188rem;
          object-fit: cover;
        }

        p {
          left: 14rem;
          top: 54rem;
        }

        h5 {
          font-size: 21rem;
          top: 14rem;
          left: 14rem;
          right: 13rem;
          white-space: normal;
          box-sizing: border-box;
        }
      }
    }
  }

  // 技术路径
  .technology-path {
    margin-top: 53rem;

    .tp-item {
      flex-direction: column;
      width: 100%;
      height: auto;

      .tp-text {
        width: 100%;
        height: auto;
      }

      .tp-pic {
        width: 100%;
        height: 0;
        padding-top: 62.87%;
      }
    }
  }

  // 作品案例
  .case {
    .list {
      margin-top: 34rem;

      li {
        .logo {
          top: 18rem;
          left: 18rem;
        }

        .text {
          left: 18rem;
          right: 18rem;
          bottom: 18rem;

          .tips {
            display: none;
          }

          .desc {
            font-size: 14rem;
          }

          h3 {
            font-size: 21rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }

    .more {
      display: none;
    }
  }

  // 跨界基因
  .cross {
    display: block;
    margin-top: 53rem;

    .title {
      font-size: 28rem;
      line-height: 34rem;
    }

    .list {
      display: flex;
      margin-top: 40rem;
      margin-left: 0;
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 10rem;

      .item {
        flex-shrink: 0;
        margin-right: 20rem;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .body-line.mt30 {
    margin-top: 50rem;
    margin-bottom: 50rem;
  }

  .banner {
    .top {
      padding: 15rem 0 8rem;

      .title {
        max-width: 100%;
        letter-spacing: normal;
        padding-top: 0;
        font-size: 28rem;
        line-height: 1.3em;
        margin-bottom: 15rem;
      }

      .right {
        .button {
          svg {
            margin-left: 10rem;
            width: 28rem;
            height: 28rem;
          }
        }
      }
    }
  }

  // 解决方案
  .solution {
    padding-bottom: 0;

    .solution-title {
      >div {
        font-size: 22rem;
        padding: 30rem 0 15rem;
      }
    }

    .tab {
      >div {
        font-size: 14rem;
        margin-right: 20rem;
        margin-top: 15rem;

        span {
          img {
            width: 28rem;
          }
        }
      }
    }

    .list-title {
      padding-top: 20rem;

      p {
        font-size: 14rem;
        line-height: 1.3em;
        padding-top: 8rem;
        padding-bottom: 25rem;
      }

      span {
        font-size: 14rem;
      }
    }

    .list {
      padding-left: 0;

      >div {
        width: 100% !important;
        padding: 15rem 0 !important;
        align-items: center;
        height: auto !important;
        display: flex;
        ;
        margin: 10rem 0;

        &:nth-child(odd),
        &:nth-child(even) {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        &::before {
          margin-bottom: -7rem;
        }

        &:nth-last-child(2) {
          &::before {
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            content: '';
            width: 100%;
            height: 1px;
            background: #2b2b2b;
          }

        }

        >img {
          width: 50rem;
          height: 50rem;
          min-width: 28rem;
          margin-right: 12rem;
          margin-bottom: 0;
        }

        h5 {
          font-size: 14rem;
          max-width: 100%;
          height: auto;
          display: block;
          white-space: normal;
          font-weight: normal;
        }

        p {
          font-size: 12rem;
          height: auto;
          display: block;
          -webkit-line-clamp: unset;
          line-clamp: unset;
          margin-top: 8rem;
        }
      }

      .hover-img {
        display: none;
      }
    }
  }

  // 技术路径(观点)
  .technology-path {
    margin-top: 30rem;

    .tp-col {
      flex-direction: column;
    }

    .tp-item {
      width: 100% !important;
      height: auto !important;
      flex-direction: column;

      .tp-text {
        width: 100% !important;
        height: auto !important;
        padding: 15rem 18rem 20rem;

        .bl {
          margin-top: 20rem;

          h4 {
            font-size: 17rem;
            line-height: 24rem;
          }

          .desc {
            width: 100%;
            font-size: 13rem;
            line-height: 20rem;
            margin-top: 3rem;
          }
        }
      }

      .tp-pic {
        width: 100% !important;
        height: 0 !important;
        padding-top: 55%;
      }
    }

    .more {
      font-size: 16rem;
      margin-top: 35rem;

      a {
        margin: 18rem auto;
      }
    }

    .tp-item:hover {
      .tp-text {
        .en {
          color: #000;
        }

        .bl {
          h4 {
            transform: translateY(0rem);
            transition: transform 0.6s;
          }

          .desc {
            transform: translateY(0rem);
            transition: transform 0.6s 0.1s;
          }
        }
      }

      .tp-pic {
        .tp-img {
          // opacity: 0;
          transform: scale(1.05);
        }

        // .tp-img-hover {
        //   opacity: 1;
        //   transform: scale(1);
        // }
      }
    }



  }

  // 品牌跑马灯
  .brand-marquee {
    margin-top: 30rem;

    .marquee-row {
      margin-bottom: 10rem;

      .pic {
        height: 80rem;
        width: calc((100% - 45rem) / 3);
        margin-right: 15rem;
      }
    }
  }

  // 作品案例
  .case {
    margin-top: 30rem;

    .topping {
      display: none;
    }

    .ue-info {
      display: block;

      .pic {
        padding-top: 56.22% !important;
        height: 0 !important;
        position: relative;
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          object-fit: cover;
        }
      }

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10rem;

        .l {
          display: flex;
          align-items: center;
          gap: 10rem;

          .date {
            font-size: 13rem;
            color: #86868b;
          }

          .tips {
            font-size: 13rem;
            color: #86868b;
          }
        }

        .r {
          .logo {
            height: 60rem;
          }
        }
      }

      .tit {
        font-size: 20rem;
        font-weight: 500;
        margin-top: 8rem;
        line-height: 1.4em;
      }
    }

    .list {
      display: block;
      margin-top: 20rem;

      li {
        width: 100% !important;
        margin-top: 20rem;

        .logo {
          top: 12rem;
          left: 12rem;
          max-width: 40rem;
          max-height: 25rem;
        }

        .text {
          left: 12rem;
          right: 12rem;
          bottom: 12rem;

          h3 {
            font-size: 14rem;
          }

          .desc {
            font-size: 13rem;
            opacity: 0.7;
          }

          .tips {
            font-size: 12rem;
          }
        }
      }
    }

    .more {
      display: none;
    }
  }

  // 行业累计
  .accumulate {
    margin-top: 30rem;

    .title {
      font-size: 22rem;
      line-height: 1.3em;
    }

    .list {
      margin-top: 20rem;

      ul {
        li {
          width: 50%;
          height: auto;
          padding: 12rem 0;
          border-right: 1px solid #2b2b2b;
          border-bottom: none;

          &:nth-child(2n) {
            border-right: none;
          }


          &:nth-child(3) {
            border-right: 1px solid #2b2b2b;
            border-bottom: 1px solid #2b2b2b;
          }

          &:nth-child(4) {
            border-bottom: 1px solid #2b2b2b;
          }

          &:nth-child(5) {
            border-top: none;
          }

          span {
            font-size: 26rem;
            line-height: 1.5em;
            height: auto;
            font-style: normal;
          }

          p {
            font-size: 13rem;
            margin-top: 8rem;
          }

          &::after {
            display: none;
          }
        }
      }
    }
  }

  // 荣誉
  .honor {
    margin-top: 30rem;

    .title {
      font-size: 22rem;
      line-height: 1.3em;
    }

    .list {
      margin-top: 15rem;

      ul {
        li {
          width: 33.33%;
          height: 80rem;
        }
      }
    }
  }

  // 核心服务应用
  .service-app {
    margin: 30rem 0 20rem;

    h3 {
      font-size: 22rem;
      margin-left: 0;
      font-weight: normal;
    }

    .list {
      margin-top: 20rem;

      .item {
        margin-top: 0;
        width: 100%;
      }

      .con {
        width: 100%;
        height: 160rem;

        p {
          top: 39rem;
          margin-right: 24rem;
        }

        h5 {
          font-size: 14rem;
          top: 10rem;
          left: 10rem;
          font-weight: normal;
        }
      }
    }
  }

  // 跨界基因
  .cross {
    margin-top: 30rem;

    .title {
      font-size: 22rem;
      line-height: 30rem;
      white-space: normal;
    }

    .list {
      margin-top: 25rem;

      .item {
        width: 310rem;
        height: 400rem;
        margin-right: 0rem;
        margin-bottom: 20rem;

        .mask {
          opacity: 1;
          transition: none;
        }

        .con {
          .icon {
            width: 70rem;
            height: 70rem;
            transform: translate(-50%, -180rem);
            transition: none;
          }

          .info {
            padding: 25rem 20rem 30rem;
            transform: translateY(0);
            transition: none;
            height: 72%;

            h5 {
              font-size: 17rem;
              line-height: 24rem;
              opacity: 1;
              transform: translateY(0);
              transition: none;
            }

            .desc {
              width: 100%;
              font-size: 14rem;
              line-height: 22rem;
              margin-top: 12rem;
              opacity: 1;
              transform: translateY(0);
              transition: none;
            }

            .detail {
              width: 100%;
              font-size: 14rem;
              line-height: 22rem;
              margin-top: 24rem;
              opacity: 1;
              transform: translateY(0);
              transition: none;
            }
          }
        }
      }
    }
  }
}
</style>


<style lang="less">
.banner .top .title {
  h5 {
    font-size: 32rem;
    font-weight: 400;
  }
}

@media only screen and (max-width: 1200px) {

  .banner .top .title h5 {
    font-size: 22rem;
  }
}
</style>
<style>
.case {
  .topping {
    &:hover {
      .left {
        h3 {
          &::after {
            transform: scaleX(1) !important;
          }
        }
      }
    }
  }
}
</style>